const messages = {
  en: {
    cancel: "Cancel",
    contact_us: "Contact us",
    get_in_touch: "Get in touch",
    email: "Email",
    email_placeholder: "name@example.com",
    subject_optional: "Subject (optional)",
    subject_placeholder: "What can we help you with?",
    your_message: "Your message",
    message_placeholder: "Type your message here\u2026",
    send_message: "Send message",
    message_sent_success: "Message sent successfully. We will get back to you soon.",
    message_send_error: "Something went wrong. Please try again later",
    invalid_email: "The input is not valid Email!",
    required_email: "Please input your Email!",
    required_message: "Please input your message",
    matches: "Matches",
    competitions: "Competitions",
    all: "All",
    home: "Home",
    away: "Away",
    assist: "Assist",
    goal: "Goal",
    missed_penalty: "Missed penalty",
    penalty: "Penalty",
    red_cards: "Red cards",
    yellow_cards: "Yellow cards",
    see_more: "See more",
    view_more: "View more",
    view_less: "View less",
    teams: "Teams",
    leagues: "Leagues",
    players: "Players",
    my_favorites: "My Favorites",
    new_favorites: "New favorites",
    add_new_favorites: "Add new favorites",
    recommendations: "Recommendations",
    no_favorite_matches_found: "No favorite matches found.",
    search: "Search",
    no_results_suggestion: "No results. Want to try something else ?",
    top_leagues: "Top Leagues",
    countries: "Countries",
    national_teams: "National Teams",
    club_international: "Club International",
    videos: "Videos",
    news: "News",
    stats: "Stats",
    special_stats: "Special Stats",
    bookmakers: "Bookmakers",
    bookmakers_heading: "Top Bookmakers",
    bookmakers_tagline: "Compare Bonuses, Ratings & Offers",
    bookmakers_description: "Discover the best online bookmakers in one place. Compare welcome bonuses, ratings, and payment options, and claim exclusive offers to start your betting journey today.",
    favorites: "Favorites",
    bookmaker_col: "Bookmaker",
    rating_col: "Rating",
    payment_col: "Payment",
    welcome_bonus_col: "Welcome Bonus",
    claim_now: "Claim Now",
    claim_offer: "Claim Offer",
    best_offer: "Best offer",
    hot: "HOT",
    ratings: "ratings",
    wc_2026: "WC 2026",
    wc_history: "WC History",
    dark_mode: "Dark Mode",
    language: "Language",
    english: "English",
    russian: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439",
    spanish: "Espa\xF1ol",
    portuguese: "Portugu\xEAs",
    privacy_policy: "Privacy",
    terms_of_use: "Terms",
    download_app: "Download Inscore App",
    download_app_subtitle: "Get the latest scores and updates for your favorite football matches with our Inscore App!",
    app_store: "App Store",
    google_play: "Google Play",
    copyright: "\xA9 All rights reserved. Inscore 2026",
    no_videos_available: "No videos available",
    start_date: "Start date",
    today: "Today",
    live: "Live",
    end_date: "End date",
    career_trophies: "Career Trophies",
    no_data_yet: "No data yet.",
    age: "Age",
    years: "years",
    birthday: "Birthday",
    nationality: "Nationality",
    shirt: "Shirt",
    player_type: "Player Type",
    position: "Position",
    height: "Height",
    cm: "cm",
    weight: "Weight",
    kg: "kg",
    preferred_foot: "Preferred foot",
    market_value: "Market value",
    started: "Started",
    assists: "Assists",
    goals: "Goals",
    minutes_played: "Minutes Played",
    lineups: "Lineups",
    rating: "Rating",
    substitute_on: "Substitute on",
    from: "from",
    to: "to",
    transfer: "Transfer",
    won_with: "Won with",
    statistics_category: "Statistics Category",
    stats_updated_note: "Stats are updated after each match. The difference column shows the total for and against values.",
    team: "Team",
    choose_minute_range: "Choose Up To Which Minute",
    choose_total: "Choose Total",
    min_short: "min",
    table_col_p: "P",
    table_col_w: "W",
    table_col_l: "L",
    table_col_d: "D",
    table_col_gd: "GD",
    table_col_pts: "PTS"
  },
  ru: {
    cancel: "\u041E\u0442\u043C\u0435\u043D\u0430",
    get_in_touch: "\u0421\u0432\u044F\u0436\u0438\u0442\u0435\u0441\u044C \u0441 \u043D\u0430\u043C\u0438",
    email: "\u042D\u043B. \u043F\u043E\u0447\u0442\u0430",
    email_placeholder: "name@example.com",
    subject_optional: "\u0422\u0435\u043C\u0430 (\u043D\u0435\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E)",
    subject_placeholder: "\u0427\u0435\u043C \u043C\u044B \u043C\u043E\u0436\u0435\u043C \u043F\u043E\u043C\u043E\u0447\u044C?",
    your_message: "\u0412\u0430\u0448\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
    message_placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0432\u0430\u0448\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435\u2026",
    send_message: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
    message_sent_success: "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E. \u041C\u044B \u043E\u0442\u0432\u0435\u0442\u0438\u043C \u0432 \u0431\u043B\u0438\u0436\u0430\u0439\u0448\u0435\u0435 \u0432\u0440\u0435\u043C\u044F.",
    message_send_error: "\u0427\u0442\u043E-\u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u0437\u0436\u0435",
    invalid_email: "\u0412\u0432\u0435\u0434\u0451\u043D\u043D\u044B\u0439 email \u043D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u0435\u043D!",
    required_email: "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 Email!",
    required_message: "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
    matches: "\u041C\u0430\u0442\u0447\u0438",
    competitions: "\u0422\u0443\u0440\u043D\u0438\u0440\u044B",
    all: "\u0412\u0441\u0435",
    home: "\u0414\u043E\u043C\u0430",
    away: "\u0412 \u0433\u043E\u0441\u0442\u044F\u0445",
    assist: "\u0410\u0441\u0441\u0438\u0441\u0442",
    goal: "\u0413\u043E\u043B",
    missed_penalty: "\u041D\u0435\u0440\u0435\u0430\u043B\u0438\u0437\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u043F\u0435\u043D\u0430\u043B\u044C\u0442\u0438",
    penalty: "\u041F\u0435\u043D\u0430\u043B\u044C\u0442\u0438",
    red_cards: "\u041A\u0440\u0430\u0441\u043D\u044B\u0435 \u043A\u0430\u0440\u0442\u043E\u0447\u043A\u0438",
    yellow_cards: "\u0416\u0451\u043B\u0442\u044B\u0435 \u043A\u0430\u0440\u0442\u043E\u0447\u043A\u0438",
    see_more: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435",
    view_more: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435",
    view_less: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u043C\u0435\u043D\u044C\u0448\u0435",
    teams: "\u041A\u043E\u043C\u0430\u043D\u0434\u044B",
    leagues: "\u041B\u0438\u0433\u0438",
    players: "\u0418\u0433\u0440\u043E\u043A\u0438",
    my_favorites: "\u041C\u043E\u0438 \u0438\u0437\u0431\u0440\u0430\u043D\u043D\u044B\u0435",
    new_favorites: "\u041D\u043E\u0432\u044B\u0435 \u0438\u0437\u0431\u0440\u0430\u043D\u043D\u044B\u0435",
    add_new_favorites: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0432 \u0438\u0437\u0431\u0440\u0430\u043D\u043D\u043E\u0435",
    recommendations: "\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0430\u0446\u0438\u0438",
    no_favorite_matches_found: "\u0418\u0437\u0431\u0440\u0430\u043D\u043D\u044B\u0445 \u043C\u0430\u0442\u0447\u0435\u0439 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E.",
    search: "\u041F\u043E\u0438\u0441\u043A",
    no_results_suggestion: "\u041D\u0435\u0442 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u0432. \u0425\u043E\u0442\u0438\u0442\u0435 \u043F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C \u0447\u0442\u043E-\u0442\u043E \u0434\u0440\u0443\u0433\u043E\u0435?",
    top_leagues: "\u0422\u043E\u043F \u043B\u0438\u0433\u0438",
    countries: "\u0421\u0442\u0440\u0430\u043D\u044B",
    national_teams: "\u0421\u0431\u043E\u0440\u043D\u044B\u0435",
    club_international: "\u041A\u043B\u0443\u0431\u043D\u044B\u0439 \u043C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u044B\u0439",
    videos: "\u0412\u0438\u0434\u0435\u043E",
    news: "\u041D\u043E\u0432\u043E\u0441\u0442\u0438",
    stats: "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430",
    special_stats: "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430",
    bookmakers: "\u0411\u0443\u043A\u043C\u0435\u043A\u0435\u0440\u044B",
    bookmakers_heading: "\u0422\u043E\u043F \u0431\u0443\u043A\u043C\u0435\u043A\u0435\u0440\u043E\u0432",
    bookmakers_tagline: "\u0421\u0440\u0430\u0432\u043D\u0438\u0442\u0435 \u0431\u043E\u043D\u0443\u0441\u044B, \u0440\u0435\u0439\u0442\u0438\u043D\u0433\u0438 \u0438 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F",
    bookmakers_description: "\u041E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \u0434\u043B\u044F \u0441\u0435\u0431\u044F \u043B\u0443\u0447\u0448\u0438\u0445 \u043E\u043D\u043B\u0430\u0439\u043D-\u0431\u0443\u043A\u043C\u0435\u043A\u0435\u0440\u043E\u0432 \u0432 \u043E\u0434\u043D\u043E\u043C \u043C\u0435\u0441\u0442\u0435. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u0435 \u043F\u0440\u0438\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0435 \u0431\u043E\u043D\u0443\u0441\u044B, \u0440\u0435\u0439\u0442\u0438\u043D\u0433\u0438 \u0438 \u0441\u043F\u043E\u0441\u043E\u0431\u044B \u043E\u043F\u043B\u0430\u0442\u044B \u0438 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 \u044D\u043A\u0441\u043A\u043B\u044E\u0437\u0438\u0432\u043D\u044B\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F, \u0447\u0442\u043E\u0431\u044B \u043D\u0430\u0447\u0430\u0442\u044C \u0434\u0435\u043B\u0430\u0442\u044C \u0441\u0442\u0430\u0432\u043A\u0438.",
    favorites: "\u0418\u0437\u0431\u0440\u0430\u043D\u043D\u043E\u0435",
    bookmaker_col: "\u0411\u0443\u043A\u043C\u0435\u043A\u0435\u0440",
    rating_col: "\u0420\u0435\u0439\u0442\u0438\u043D\u0433",
    payment_col: "\u041E\u043F\u043B\u0430\u0442\u0430",
    welcome_bonus_col: "\u041F\u0440\u0438\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0439 \u0431\u043E\u043D\u0443\u0441",
    claim_now: "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C",
    claim_offer: "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C",
    best_offer: "\u041B\u0443\u0447\u0448\u0435\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435",
    hot: "HOT",
    ratings: "\u043E\u0446\u0435\u043D\u043E\u043A",
    wc_2026: "\u0427\u041C 2026",
    wc_history: "\u0418\u0441\u0442\u043E\u0440\u0438\u044F \u0427\u041C",
    dark_mode: "\u0422\u0451\u043C\u043D\u0430\u044F \u0442\u0435\u043C\u0430",
    language: "\u042F\u0437\u044B\u043A",
    english: "English",
    russian: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439",
    spanish: "\u0418\u0441\u043F\u0430\u043D\u0441\u043A\u0438\u0439",
    portuguese: "\u041F\u043E\u0440\u0442\u0443\u0433\u0430\u043B\u044C\u0441\u043A\u0438\u0439",
    privacy_policy: "\u041A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u044C",
    terms_of_use: "\u0423\u0441\u043B\u043E\u0432\u0438\u044F",
    contact_us: "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u044B",
    download_app: "\u0421\u043A\u0430\u0447\u0430\u0442\u044C \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 Inscore",
    download_app_subtitle: "\u041F\u043E\u043B\u0443\u0447\u0430\u0439\u0442\u0435 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0435 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B \u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F \u043F\u043E \u0432\u0430\u0448\u0438\u043C \u043B\u044E\u0431\u0438\u043C\u044B\u043C \u0444\u0443\u0442\u0431\u043E\u043B\u044C\u043D\u044B\u043C \u043C\u0430\u0442\u0447\u0430\u043C \u0441 \u043D\u0430\u0448\u0438\u043C \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043C Inscore!",
    app_store: "App Store",
    google_play: "Google Play",
    copyright: "\xA9 \u0412\u0441\u0435 \u043F\u0440\u0430\u0432\u0430 \u0437\u0430\u0449\u0438\u0449\u0435\u043D\u044B. Inscore 2026",
    no_videos_available: "\u0412\u0438\u0434\u0435\u043E \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B",
    start_date: "\u0414\u0430\u0442\u0430 \u043D\u0430\u0447\u0430\u043B\u0430",
    today: "\u0421\u0435\u0433\u043E\u0434\u043D\u044F",
    live: "\u041B\u0430\u0439\u0432",
    end_date: "\u0414\u0430\u0442\u0430 \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u044F",
    career_trophies: "\u0422\u0440\u043E\u0444\u0435\u0438 \u043A\u0430\u0440\u044C\u0435\u0440\u044B",
    no_data_yet: "\u0414\u0430\u043D\u043D\u044B\u0435 \u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u044E\u0442.",
    age: "\u0412\u043E\u0437\u0440\u0430\u0441\u0442",
    years: "\u043B\u0435\u0442",
    birthday: "\u0414\u0435\u043D\u044C \u0440\u043E\u0436\u0434\u0435\u043D\u0438\u044F",
    nationality: "\u0413\u0440\u0430\u0436\u0434\u0430\u043D\u0441\u0442\u0432\u043E",
    shirt: "\u041D\u043E\u043C\u0435\u0440",
    player_type: "\u0422\u0438\u043F \u0438\u0433\u0440\u043E\u043A\u0430",
    position: "\u041F\u043E\u0437\u0438\u0446\u0438\u044F",
    height: "\u0420\u043E\u0441\u0442",
    cm: "\u0441\u043C",
    weight: "\u0412\u0435\u0441",
    kg: "\u043A\u0433",
    preferred_foot: "\u041F\u0440\u0435\u0438\u043C\u0443\u0449\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u0430\u044F \u043D\u043E\u0433\u0430",
    market_value: "\u0421\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u0440\u044B\u043D\u043A\u0430",
    started: "\u0412 \u0441\u0442\u0430\u0440\u0442\u043E\u0432\u043E\u043C \u0441\u043E\u0441\u0442\u0430\u0432\u0435",
    assists: "\u0410\u0441\u0441\u0438\u0441\u0442\u044B",
    goals: "\u0413\u043E\u043B\u044B",
    minutes_played: "\u041C\u0438\u043D\u0443\u0442\u044B",
    lineups: "\u0421\u043E\u0441\u0442\u0430\u0432\u044B",
    rating: "\u0420\u0435\u0439\u0442\u0438\u043D\u0433",
    substitute_on: "\u0417\u0430\u043C\u0435\u043D\u0451\u043D",
    from: "\u043E\u0442",
    to: "\u0432",
    transfer: "\u0422\u0440\u0430\u043D\u0441\u0444\u0435\u0440",
    won_with: "\u0412\u044B\u0438\u0433\u0440\u0430\u043B \u0441",
    statistics_category: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0438",
    stats_updated_note: "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430 \u043E\u0431\u043D\u043E\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043F\u043E\u0441\u043B\u0435 \u043A\u0430\u0436\u0434\u043E\u0433\u043E \u043C\u0430\u0442\u0447\u0430. \u0421\u0442\u043E\u043B\u0431\u0435\u0446 \xAB\u0420\u0430\u0437\u043D\u0438\u0446\u0430\xBB \u043F\u043E\u043A\u0430\u0437\u044B\u0432\u0430\u0435\u0442 \u0441\u0443\u043C\u043C\u0430\u0440\u043D\u044B\u0435 \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u0435\u043B\u0438 \u0437\u0430 \u0438 \u043F\u0440\u043E\u0442\u0438\u0432.",
    team: "\u041A\u043E\u043C\u0430\u043D\u0434\u0430",
    choose_minute_range: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0414\u043E \u041A\u0430\u043A\u043E\u0439 \u041C\u0438\u043D\u0443\u0442\u044B",
    choose_total: "\u0412\u044B\u0431\u0435\u0440\u0438 \u0422\u043E\u0442\u0430\u043B",
    min_short: "\u043C\u0438\u043D",
    table_col_p: "\u0418",
    table_col_w: "\u041F",
    table_col_l: "\u041F\u0440",
    table_col_d: "\u041D",
    table_col_gd: "\u0420\u041C",
    table_col_pts: "\u041E\u0427",
    stats_col_matches: "\u041C\u0430\u0442\u0447\u0438",
    stats_col_wins: "\u041F\u043E\u0431\u0435\u0434\u044B",
    stats_col_draws: "\u041D\u0438\u0447\u044C\u0438",
    stats_col_loses: "\u041F\u043E\u0440\u0430\u0436\u0435\u043D\u0438\u044F",
    stats_col_difference: "\u0420\u0430\u0437\u043D\u0438\u0446\u0430",
    stats_col_points: "\u041E\u0447\u043A\u0438",
    stats_col_yes: "\u0414\u0430",
    stats_col_no: "\u041D\u0435\u0442",
    stats_col_over: "\u0411\u043E\u043B\u044C\u0448\u0435",
    stats_col_under: "\u041C\u0435\u043D\u044C\u0448\u0435",
    stats_filter_all: "\u0432\u0441\u0435",
    stats_filter_home: "\u0434\u043E\u043C\u0430",
    stats_filter_away: "\u0432 \u0433\u043E\u0441\u0442\u044F\u0445",
    stats_filter_match: "\u041C\u0430\u0442\u0447",
    stats_filter_firstHalf: "1-\u044B\u0439 \u0442\u0430\u0439\u043C",
    stats_filter_secondHalf: "2-\u043E\u0439 \u0442\u0430\u0439\u043C",
    stats_subject_16: "\u0413\u043E\u043B\u044B",
    stats_subject_17: "\u0413\u043E\u043B\u044B \u0411\u043E\u043B\u044C\u0448\u0435/\u041C\u0435\u043D\u044C\u0448\u0435",
    stats_subject_0: "\u0423\u0433\u043B\u043E\u0432\u044B\u0435",
    stats_subject_6: "\u0423\u0433\u043B\u043E\u0432\u044B\u0435 \u0411\u043E\u043B\u044C\u0448\u0435/\u041C\u0435\u043D\u044C\u0448\u0435",
    stats_subject_1: "\u0416\u0435\u043B\u0442\u044B\u0435 \u043A\u0430\u0440\u0442\u043E\u0447\u043A\u0438",
    stats_subject_8: "\u0416\u0435\u043B\u0442\u044B\u0435 \u043A\u0430\u0440\u0442\u043E\u0447\u043A\u0438 \u0411\u043E\u043B\u044C\u0448\u0435/\u041C\u0435\u043D\u044C\u0448\u0435",
    stats_subject_2: "\u041E\u0444\u0441\u0430\u0439\u0434\u044B",
    stats_subject_9: "\u041E\u0444\u0441\u0430\u0439\u0434\u044B \u0411\u043E\u043B\u044C\u0448\u0435/\u041C\u0435\u043D\u044C\u0448\u0435",
    stats_subject_3: "\u0423\u0434\u0430\u0440\u044B",
    stats_subject_10: "\u0423\u0434\u0430\u0440\u044B \u0411\u043E\u043B\u044C\u0448\u0435/\u041C\u0435\u043D\u044C\u0448\u0435",
    stats_subject_5: "\u0410\u0443\u0442\u044B",
    stats_subject_12: "\u0410\u0443\u0442\u044B \u0411\u043E\u043B\u044C\u0448\u0435/\u041C\u0435\u043D\u044C\u0448\u0435",
    stats_subject_4: "\u0424\u043E\u043B\u044B",
    stats_subject_11: "\u0424\u043E\u043B\u044B \u0411\u043E\u043B\u044C\u0448\u0435/\u041C\u0435\u043D\u044C\u0448\u0435",
    stats_subject_13: "\u041A\u0440\u0430\u0441\u043D\u044B\u0435 \u043A\u0430\u0440\u0442\u043E\u0447\u043A\u0438",
    stats_subject_14: "\u041F\u0435\u043D\u0430\u043B\u044C\u0442\u0438",
    stats_subject_15: "\u0411\u044B\u0441\u0442\u0440\u044B\u0439 \u0433\u043E\u043B",
    stats_subject_18: "\u0422\u0430\u0431\u043B\u0438\u0446\u0430"
  },
  es: {
    cancel: "Cancelar",
    contact_us: "Cont\xE1ctanos",
    get_in_touch: "Ponte en contacto",
    email: "Correo electr\xF3nico",
    email_placeholder: "name@example.com",
    subject_optional: "Asunto (opcional)",
    subject_placeholder: "\xBFEn qu\xE9 podemos ayudarte?",
    your_message: "Tu mensaje",
    message_placeholder: "Escribe tu mensaje aqu\xED\u2026",
    send_message: "Enviar mensaje",
    message_sent_success: "Mensaje enviado correctamente. Te responderemos pronto.",
    message_send_error: "Algo sali\xF3 mal. Por favor, int\xE9ntalo de nuevo m\xE1s tarde",
    invalid_email: "La entrada no es un correo v\xE1lido!",
    required_email: "Por favor, introduce tu correo!",
    required_message: "Por favor, introduce tu mensaje",
    matches: "Partidos",
    competitions: "Competiciones",
    all: "Todos",
    home: "Local",
    away: "Visitante",
    assist: "Asistencia",
    goal: "Gol",
    missed_penalty: "Penal fallado",
    penalty: "Penal",
    red_cards: "Tarjetas rojas",
    yellow_cards: "Tarjetas amarillas",
    see_more: "Ver m\xE1s",
    view_more: "Ver m\xE1s",
    view_less: "Ver menos",
    teams: "Equipos",
    leagues: "Ligas",
    players: "Jugadores",
    my_favorites: "Mis favoritos",
    new_favorites: "Nuevos favoritos",
    add_new_favorites: "Agregar nuevos favoritos",
    recommendations: "Recomendaciones",
    no_favorite_matches_found: "No se encontraron partidos favoritos.",
    search: "Buscar",
    no_results_suggestion: "Sin resultados. \xBFQuieres intentar con otra b\xFAsqueda?",
    top_leagues: "Principales ligas",
    countries: "Pa\xEDses",
    national_teams: "Selecciones nacionales",
    club_international: "Club Internacional",
    videos: "V\xEDdeos",
    news: "Noticias",
    stats: "Estad\xEDsticas",
    special_stats: "Estad\xEDsticas",
    bookmakers: "Casas de apuestas",
    bookmakers_heading: "Mejores casas de apuestas",
    bookmakers_tagline: "Compara bonos, valoraciones y ofertas",
    bookmakers_description: "Descubre las mejores casas de apuestas online en un solo lugar. Compara bonos de bienvenida, valoraciones y opciones de pago, y reclama ofertas exclusivas para empezar a apostar hoy.",
    favorites: "Favoritos",
    bookmaker_col: "Casa de apuestas",
    rating_col: "Valoraci\xF3n",
    payment_col: "Pago",
    welcome_bonus_col: "Bono de bienvenida",
    claim_now: "Reclamar ahora",
    claim_offer: "Reclamar",
    best_offer: "Mejor oferta",
    hot: "HOT",
    ratings: "valoraciones",
    wc_2026: "WC 2026",
    wc_history: "Historia WC",
    dark_mode: "Modo oscuro",
    language: "Idioma",
    english: "English",
    russian: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439",
    spanish: "Espa\xF1ol",
    portuguese: "Portugu\xEAs",
    privacy_policy: "Privacidad",
    terms_of_use: "T\xE9rminos",
    download_app: "Descarga la aplicaci\xF3n Inscore",
    download_app_subtitle: "Obt\xE9n los \xFAltimos resultados y actualizaciones de tus partidos de f\xFAtbol favoritos con nuestra aplicaci\xF3n Inscore!",
    app_store: "App Store",
    google_play: "Google Play",
    copyright: "\xA9 Todos los derechos reservados. Inscore 2026",
    no_videos_available: "No hay videos disponibles",
    start_date: "Fecha de inicio",
    today: "Hoy",
    live: "Live",
    end_date: "Fecha de fin",
    career_trophies: "Trofeos de carrera",
    no_data_yet: "No hay datos.",
    age: "Edad",
    years: "a\xF1os",
    birthday: "Cumplea\xF1os",
    nationality: "Nacionalidad",
    shirt: "Camiseta",
    player_type: "Tipo de jugador",
    position: "Posici\xF3n",
    height: "Altura",
    cm: "cm",
    weight: "Peso",
    kg: "kg",
    preferred_foot: "Pie preferido",
    market_value: "Valor de mercado",
    started: "Titular",
    assists: "Asistencias",
    goals: "Goles",
    minutes_played: "Minutos jugados",
    lineups: "Alineaciones",
    rating: "Calificaci\xF3n",
    substitute_on: "Sustituido",
    from: "de",
    to: "a",
    transfer: "Transferencia",
    won_with: "Gan\xF3 con",
    statistics_category: "Categor\xEDa de estad\xEDsticas",
    stats_updated_note: "Las estad\xEDsticas se actualizan despu\xE9s de cada partido. La columna de diferencia muestra el total a favor y en contra.",
    team: "Equipo",
    choose_minute_range: "Elige hasta qu\xE9 minuto",
    choose_total: "Elige el total",
    min_short: "min",
    stats_col_matches: "Partidos",
    stats_col_wins: "Victorias",
    stats_col_draws: "Empates",
    stats_col_loses: "Derrotas",
    stats_col_difference: "Diferencia",
    stats_col_points: "Puntos",
    stats_col_yes: "S\xED",
    stats_col_no: "No",
    stats_col_over: "M\xE1s",
    stats_col_under: "Menos",
    stats_filter_all: "Todos",
    stats_filter_home: "Local",
    stats_filter_away: "Visitante",
    stats_filter_match: "Partido",
    stats_filter_firstHalf: "1.er tiempo",
    stats_filter_secondHalf: "2.\xBA tiempo",
    stats_subject_16: "Goles",
    stats_subject_17: "Goles M\xE1s/Menos",
    stats_subject_0: "C\xF3rners",
    stats_subject_6: "C\xF3rners M\xE1s/Menos",
    stats_subject_1: "Tarjetas amarillas",
    stats_subject_8: "Tarjetas amarillas M\xE1s/Menos",
    stats_subject_2: "Fueras de juego",
    stats_subject_9: "Fueras de juego M\xE1s/Menos",
    stats_subject_3: "Tiros",
    stats_subject_10: "Tiros M\xE1s/Menos",
    stats_subject_5: "Saques de banda",
    stats_subject_12: "Saques de banda M\xE1s/Menos",
    stats_subject_4: "Faltas",
    stats_subject_11: "Faltas M\xE1s/Menos",
    stats_subject_13: "Tarjetas rojas",
    stats_subject_14: "Penaltis",
    stats_subject_15: "Gol r\xE1pido",
    stats_subject_18: "Clasificaci\xF3n"
  },
  pt: {
    cancel: "Cancelar",
    contact_us: "Fale conosco",
    get_in_touch: "Entre em contato",
    email: "Email",
    email_placeholder: "name@example.com",
    subject_optional: "Assunto (opcional)",
    subject_placeholder: "Como podemos ajudar?",
    your_message: "Sua mensagem",
    message_placeholder: "Digite sua mensagem aqui\u2026",
    send_message: "Enviar mensagem",
    message_sent_success: "Mensagem enviada com sucesso. Entraremos em contato em breve.",
    message_send_error: "Algo deu errado. Por favor, tente novamente mais tarde",
    invalid_email: "O email fornecido n\xE3o \xE9 v\xE1lido!",
    required_email: "Por favor, insira seu Email!",
    required_message: "Por favor, insira sua mensagem",
    matches: "Partidas",
    competitions: "Competi\xE7\xF5es",
    all: "Todos",
    home: "Casa",
    away: "Visitante",
    assist: "Assist\xEAncia",
    goal: "Gol",
    missed_penalty: "P\xEAnalti perdido",
    penalty: "P\xEAnalti",
    red_cards: "Cart\xF5es vermelhos",
    yellow_cards: "Cart\xF5es amarelos",
    see_more: "Ver mais",
    view_more: "Ver mais",
    view_less: "Ver menos",
    teams: "Times",
    leagues: "Ligas",
    players: "Jogadores",
    my_favorites: "Meus favoritos",
    new_favorites: "Novos favoritos",
    add_new_favorites: "Adicionar novos favoritos",
    recommendations: "Recomenda\xE7\xF5es",
    no_favorite_matches_found: "Nenhuma partida favorita encontrada.",
    search: "Buscar",
    no_results_suggestion: "Sem resultados. Quer tentar outra busca?",
    top_leagues: "Principais ligas",
    countries: "Pa\xEDses",
    national_teams: "Sele\xE7\xF5es nacionais",
    club_international: "Clube Internacional",
    videos: "V\xEDdeos",
    news: "Not\xEDcias",
    stats: "Estat\xEDsticas",
    special_stats: "Estat\xEDsticas",
    bookmakers: "Casas de apostas",
    bookmakers_heading: "Melhores casas de apostas",
    bookmakers_tagline: "Compare b\xF4nus, avalia\xE7\xF5es e ofertas",
    bookmakers_description: "Descubra as melhores casas de apostas online em um s\xF3 lugar. Compare b\xF4nus de boas-vindas, avalia\xE7\xF5es e op\xE7\xF5es de pagamento, e reivindique ofertas exclusivas para come\xE7ar a apostar hoje.",
    favorites: "Favoritos",
    wc_2026: "WC 2026",
    wc_history: "Hist\xF3ria WC",
    dark_mode: "Modo escuro",
    language: "Idioma",
    english: "English",
    russian: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439",
    spanish: "Espa\xF1ol",
    privacy_policy: "Privacidade",
    terms_of_use: "Termos",
    download_app: "Baixe o aplicativo Inscore",
    download_app_subtitle: "Obtenha as \xFAltimas pontua\xE7\xF5es e atualiza\xE7\xF5es dos seus jogos de futebol favoritos com nosso aplicativo Inscore!",
    app_store: "App Store",
    google_play: "Google Play",
    copyright: "\xA9 Todos os direitos reservados. Inscore 2026",
    no_videos_available: "Nenhum v\xEDdeo dispon\xEDvel",
    start_date: "Data de in\xEDcio",
    today: "Hoje",
    live: "Live",
    end_date: "Data de t\xE9rmino",
    career_trophies: "Trof\xE9us da carreira",
    no_data_yet: "Sem dados ainda.",
    age: "Idade",
    years: "anos",
    birthday: "Anivers\xE1rio",
    nationality: "Nacionalidade",
    shirt: "Camisa",
    player_type: "Tipo de jogador",
    position: "Posi\xE7\xE3o",
    height: "Altura",
    cm: "cm",
    weight: "Peso",
    kg: "kg",
    preferred_foot: "P\xE9 preferido",
    market_value: "Valor de mercado",
    started: "Iniciado",
    assists: "Assist\xEAncias",
    goals: "Gols",
    minutes_played: "Minutos jogados",
    lineups: "Escala\xE7\xF5es",
    rating: "Avalia\xE7\xE3o",
    substitute_on: "Substitu\xEDdo",
    from: "de",
    to: "para",
    transfer: "Transfer\xEAncia",
    won_with: "Venceu com",
    statistics_category: "Categoria de estat\xEDsticas",
    stats_updated_note: "As estat\xEDsticas s\xE3o atualizadas ap\xF3s cada partida. A coluna de diferen\xE7a mostra o total a favor e contra.",
    team: "Equipe",
    choose_minute_range: "Escolha at\xE9 qual minuto",
    choose_total: "Escolha o total",
    min_short: "min",
    stats_col_matches: "Jogos",
    stats_col_wins: "Vit\xF3rias",
    stats_col_draws: "Empates",
    stats_col_loses: "Derrotas",
    stats_col_difference: "Saldo",
    stats_col_points: "Pontos",
    stats_col_yes: "Sim",
    stats_col_no: "N\xE3o",
    stats_col_over: "Mais",
    stats_col_under: "Menos",
    stats_filter_all: "Todos",
    stats_filter_home: "Casa",
    stats_filter_away: "Fora",
    stats_filter_match: "Jogo",
    stats_filter_firstHalf: "1\xBA tempo",
    stats_filter_secondHalf: "2\xBA tempo",
    stats_subject_16: "Gols",
    stats_subject_17: "Gols Mais/Menos",
    stats_subject_0: "Escanteios",
    stats_subject_6: "Escanteios Mais/Menos",
    stats_subject_1: "Cart\xF5es amarelos",
    stats_subject_8: "Cart\xF5es amarelos Mais/Menos",
    stats_subject_2: "Impedimentos",
    stats_subject_9: "Impedimentos Mais/Menos",
    stats_subject_3: "Finaliza\xE7\xF5es",
    stats_subject_10: "Finaliza\xE7\xF5es Mais/Menos",
    stats_subject_5: "Laterais",
    stats_subject_12: "Laterais Mais/Menos",
    stats_subject_4: "Faltas",
    stats_subject_11: "Faltas Mais/Menos",
    stats_subject_13: "Cart\xF5es vermelhos",
    stats_subject_14: "P\xEAnaltis",
    stats_subject_15: "Gol r\xE1pido",
    stats_subject_18: "Classifica\xE7\xE3o"
  }
};
var stdin_default = messages;
export {
  stdin_default as default
};
